import api from '../../config/APIConfig'

const { iAxios, apiUri } = api
const baseUrl = `${apiUri}/`

export const CertRevActions = {
  revocarCertificadoPost
}
function revocarCertificadoPost(params) {
    return iAxios.post(`${baseUrl}revocarCertificado`, params)
}
